import { render } from "./ActivateCard.vue?vue&type=template&id=54f465db"
import script from "./ActivateCard.vue?vue&type=script&lang=js"
export * from "./ActivateCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__